
<script lang="ts">
import { h } from 'vue'
import {ElPopover, ElTableColumn, ElTooltip} from 'element-plus';
type initSlotsType = {
    [key: string]: (scope: any) => any
}
export default {
    name: "TqTableColumn",
    data() {
        return {

        }
    },
    props: {
        ...ElTableColumn.props,
        headerAlign: {
            type: String,
            default: 'center'
        },
        ellipsisLineNumber: {
            type: Number,
            default: 0
        },
        align: {
            type: String,
            default: 'center'
        },
        popSlotName: {
            type: String,
            default: ''
        },
    },
    computed: {
        isSelectionText() {
            const allSpecialTypes = ['selection', 'index']
            return allSpecialTypes.includes(this.type)
        },
        isExpand() {
            const allSpecialTypes = ['expand']
            return allSpecialTypes.includes(this.type)
        },
        isRecursion() {
            let isRecursion = false
            if (this.$slots.default && this.$slots.default.length > 0) {
                for (let index = 0; index < this.$slots.default.length; index++) {
                    // @ts-ignore
                    const element = this.$slots.default[index];
                    if (element.componentOptions && element.componentOptions.tag === 'tq-table-column') {
                        isRecursion = true
                        break;
                    }
                }
            }
            return isRecursion;
        }
    },
    methods: {
    },
    created() {
    },
    render() {
        let basicInfo = {
            props: this.$props,
            on: this.$attrs,
        }
        if (this.isSelectionText) {
            return h(ElTableColumn, basicInfo)
        }
        if (this.isRecursion) {
            return h(ElTableColumn, basicInfo, this.$slots.default)
        }

        const initSlots:initSlotsType = {
            default: (scope) => {
                let extraInfo:any[] = []
                if (this.$slots['default'] || this.isExpand) {
                    // @ts-ignore
                    extraInfo.push(this.$slots.default({
                        ...scope
                    }) as never)
                } else {
                    if (this.$slots[this.$props.prop]) {
                        // @ts-ignore
                        extraInfo.push(this.$slots[this.$props.prop]({
                            ...scope
                        }) as never)
                    } else {
                        const dataObj:any = {}
                        if (this.$slots[this.$props.popSlotName]) {
                            const tooltipNode = h(ElPopover, {
                                props: {
                                    placement: 'bottom',
                                    trigger: 'hover'
                                }
                            }, [h('div', {
                                slot: "default",
                                class: 'tq-table-custom-popover'
                                // @ts-ignore
                            }, this.$slots[this.$props.popSlotName]({
                            ...scope
                            })), h('div', {
                                style: {
                                    width: "100%",
                                    overflow: 'hidden',
                                    'text-overflow': 'ellipsis',
                                    'white-space': 'nowrap',
                                },
                                slot: "reference",
                            }, scope.row[this.$props.prop])])
                            extraInfo.push(tooltipNode  as never)
                        } else if (this.ellipsisLineNumber > 0) {
                            dataObj.style = {
                                overflow: 'hidden',
                                'text-overflow': 'ellipsis',
                                'display': '-webkit-box',
                                '-webkit-line-clamp': this.ellipsisLineNumber,
                                '-webkit-box-orient': 'vertical',
                            }
                            const tooltipNode = h(ElTooltip, {
                                props: {
                                    content: `${scope.row[this.$props.prop]}`,
                                    placement: 'top',
                                }
                            }, [h('span', dataObj, [scope.row[this.$props.prop]])])
                            extraInfo.push(tooltipNode  as never)
                        } else {
                            extraInfo.push(scope.row[this.$props.prop]  as never)
                        }
                    }
                }
                return extraInfo
            }
        }
        if (this.$slots.header) {
            initSlots.header = (scope) => {
                let extraInfo:any = []
                if (this.$slots.header) {
                    extraInfo.push(this.$slots.header({
                        ...scope
                    }) as never)
                }
                return extraInfo
            }
        }
        if(this.$props.renderHeader) {
          initSlots.header = (scope) => {
                let extraInfo = []
                extraInfo.push(this.$props.renderHeader(scope))
                return extraInfo
            }
        }
        return h(ElTableColumn, {
            ...basicInfo,
            scopedSlots: initSlots
        },)

    }
}
</script>
